/**
 * Creates compare function to sort by an object property.
 *
 * Example:
 *
 * const sortedWidgets = widgets.sort(sortBy('name'))
 *
 * @param {string} property - the property to sort by
 * @returns compare function for use with Array.prototype.sort
 */
const sortBy = property => ((a, b) => {
  if (a[property] < b[property]) {
    return -1;
  } else if (a[property] > b[property]) {
    return 1;
  } else {
    return 0;
  }
});

/**
 * Creates compare function to sort by a string property in case-insensitive alphabetical order.
 *
 * Example:
 *
 * const sortedWidgets = widgets.sort(stringSortBy('name', 'asc'))
 *
 * @param {string} property - the property to sort by
 * @param {string} order - asc (alphabetical) or desc (reverse alphabetical)
 * @returns compare function for use with Array.prototype.sort
 */
const stringSortBy = (property, order) => ((a, b) => {
  const aLower = a[property] ? a[property].toLowerCase() : '';
  const bLower = b[property] ? b[property].toLowerCase() : '';
  const dir = order === 'desc' ? -1 : 1;
  if (aLower < bLower) {
    return -dir;
  } else if (aLower > bLower) {
    return dir;
  }
  return 0;
});

const chunk = (array, n) => {
  const chunks = [];
  let i = 0;

  while (i < array.length) {
    chunks.push(array.slice(i, i += n));
  }

  return chunks;
};

const sum = (array) => array.reduce((total, n) => (total + n), 0);

export {
  chunk,
  sortBy,
  stringSortBy,
  sum
};
